(function () {
  function showMessage(root, text) {
    var message = root.querySelector('.zj-addons__message');
    if (!message) return;
    message.textContent = text || '';
    message.hidden = !text;
  }

  async function addSelected(root, button) {
    if (button.getAttribute('aria-disabled') === 'true') return;

    var checked = Array.prototype.slice.call(root.querySelectorAll('.zj-addons__check:checked:not(:disabled)'));
    if (!checked.length) {
      showMessage(root, 'Select at least one item to add.');
      return;
    }

    var items = [];
    for (var i = 0; i < checked.length; i++) {
      var input = checked[i];
      if (input.dataset.customizationUrl) {
        window.location.assign(input.dataset.customizationUrl);
        return;
      }
      var id = input.value;
      if (input.hasAttribute('data-needs-variant')) {
        var select = input.closest('.zj-addons__item').querySelector('[data-zj-addon-variant]');
        id = select ? select.value : '';
        if (!id) {
          var name = input.closest('.zj-addons__item').querySelector('.zj-addons__title').textContent.trim();
          if (select) {
            select.setAttribute('aria-invalid', 'true');
            select.focus();
          }
          showMessage(root, 'Choose an option for ' + name + '.');
          return;
        }
      }
      items.push({ id: Number(id), quantity: 1 });
    }

    showMessage(root, '');
    button.setAttribute('aria-disabled', 'true');

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: items };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (section) { return section.id; }).join(',');
      body.sections_url = window.location.pathname;
    }

    try {
      var response = await fetch(window.routes.cart_add_url.replace(/\.js.*$/, '') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      var state = await response.json();

      if (!response.ok || state.status) {
        showMessage(root, state.description || state.message || 'Could not add these items. Please try again.');
        return;
      }

      checked.forEach(function (input) { input.checked = false; });
      root.querySelectorAll('[data-zj-addon-variant]').forEach(function (select) {
        select.value = '';
        select.removeAttribute('aria-invalid');
      });
      root.querySelectorAll('[data-zj-addon-price]').forEach(function (price) {
        if (price.dataset.from) price.textContent = price.dataset.from;
      });

      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zj-addons', cartData: state });
      }
      cart.renderContents(state);
    } catch (error) {
      console.error(error);
      showMessage(root, 'Something went wrong. Please try again.');
    } finally {
      button.removeAttribute('aria-disabled');
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-zj-addons-submit]');
    if (!button) return;
    var root = button.closest('[data-zj-addons]');
    if (root) addSelected(root, button);
  });

  document.addEventListener('change', function (event) {
    var root = event.target.closest && event.target.closest('[data-zj-addons]');
    if (!root) return;
    showMessage(root, '');
    var select = event.target.matches && event.target.matches('[data-zj-addon-variant]') ? event.target : null;
    if (!select) return;
    select.removeAttribute('aria-invalid');
    var price = select.closest('.zj-addons__item').querySelector('[data-zj-addon-price]');
    if (!price) return;
    if (!price.dataset.from) price.dataset.from = price.textContent;
    var option = select.options[select.selectedIndex];
    price.textContent = option && option.dataset.price ? option.dataset.price : price.dataset.from;
  });
})();
